// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ChartDesigner {
  export enum PaneView {
    Regular = 'REGULAR',
    Minimized = 'MINIMIZED',
    Maximized = 'MAXIMIZED',
  }

  export interface ChartPaneState {
    view: PaneView;
    height?: number;
  }

  export interface DataPaneState {
    view: PaneView;
    height?: number;
  }
}

export interface ChartDesignerState {
  chartPane: Readonly<ChartDesigner.ChartPaneState>;
  dataPane: Readonly<ChartDesigner.DataPaneState>;
}
